import { useTranslation } from "react-i18next";
import { Avatar, Box, Skeleton, Typography } from "@mui/material";

import { User } from "../../../../types/types";
import { ServiceProvider } from "../../api/types/topServiceProviders.types";

import { UserVerifiedIcon } from "../../assets/icons/go-service-icons";
import { useUserDataFormatter } from "../../../User/hooks/useUserDataFormatter";
import { Link } from "react-router-dom";

export const SummaryProviderDetails = ({ user, isProvider }: { user: User | ServiceProvider; isProvider: boolean }) => {
  const { t } = useTranslation("goService", { keyPrefix: "components" });
  const { fullName, firstTwoChr, media, club, role, isVerified, profileLink } = useUserDataFormatter(user);

  const userRole = isProvider ? t("providerDetails") : t("requesterDetails");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <Typography sx={styles.providerDetailsTitle}>{userRole}</Typography>
      <Box sx={styles.userInfoContainer}>
        <Box sx={styles.avatarContainer}>
          <Avatar src={media} sx={styles.avatar}>
            {firstTwoChr}
          </Avatar>
          {isVerified && <UserVerifiedIcon sx={styles.verifiedIcon} />}
        </Box>
        <Box sx={styles.userInfo}>
          <Typography sx={styles.userName} component={Link} to={profileLink}>
            {fullName}
          </Typography>
          <Typography sx={styles.userRole}>
            {role} {club && `• ${club}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export const SummaryProviderDetailsLoader = () => {
  return (
    <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
      <Skeleton variant="circular" width={44} height={44} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", flex: 1 }}>
        <Skeleton variant="rounded" width={150} height={24} />
        <Skeleton variant="rounded" width={100} height={18} />
      </Box>
    </Box>
  );
};

const styles = {
  userInfoContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  avatarContainer: {
    position: "relative",
  },
  avatar: {
    width: "44px",
    height: "44px",
  },
  verifiedIcon: {
    position: "absolute",
    bottom: "-6px",
    left: "22px",
    transform: "translateX(-50%)",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  userName: {
    textDecoration: "none",
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  },
  userRole: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "18px",
  },
  providerDetailsTitle: {
    fontFamily: "Montserrat",
    color: "#707070",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
};
